import { FC, ReactNode } from "react";

import { Book, Close } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  children: ReactNode;
  onClose: () => void;
  dataTestId?: string;
}

export const Tip: FC<IProps> = ({ children, onClose, dataTestId }) => {
  return (
    <Flex
      bg={withVar(DesignToken.SurfaceSecondaryDefault)}
      justifyContent="space-between"
      alignItems="center"
      paddingV={withVar(SpacingToken.Spacing1)}
      paddingH={withVar(SpacingToken.Spacing3)}
      borderRadius={withVar(RadiusToken.Radius3)}
      data-testid={dataTestId}
    >
      <Flex gap={withVar(SpacingToken.Spacing2)}>
        <Icon source={Book} size="small" />
        <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>{children}</Text>
      </Flex>
      <Button kind="plain" icon={<Icon source={Close} />} onClick={onClose} size="xcompact" />
    </Flex>
  );
};
